module.exports = __webpack_public_path__ + "img/instagram.f2cf5527.svg";